import { Effect } from "../../Materials/effect";
var name = 'kernelBlurVaryingDeclaration';
var shader = "varying vec2 sampleCoord{X};";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */
export var kernelBlurVaryingDeclaration = { name: name, shader: shader };
//# sourceMappingURL=kernelBlurVaryingDeclaration.js.map